/**
 * Server calls in flight, so the page can say so when one is slow.
 *
 * A Cloud Function that has not been used for a while takes about 5 s to
 * start (8 s in the slowest tenth, up to ~20 s seen), and a button that just
 * spins that long reads as broken. Every httpsCallable goes through
 * trackRequest (see firebase-functions-shim.ts); SlowRequestNotice shows a
 * message while the oldest call is still running.
 */
type Listener = (oldestStartedAt: number | null) => void;

const inflight = new Map<number, number>();
const listeners = new Set<Listener>();
let seq = 0;

function oldest(): number | null {
  let min: number | null = null;
  inflight.forEach((t) => { if (min === null || t < min) min = t; });
  return min;
}
function emit() {
  const o = oldest();
  listeners.forEach((l) => l(o));
}

export function trackRequest<T>(promise: Promise<T>): Promise<T> {
  const id = ++seq;
  inflight.set(id, Date.now());
  emit();
  return promise.finally(() => {
    inflight.delete(id);
    emit();
  });
}

export function subscribeSlowRequests(listener: Listener): () => void {
  listeners.add(listener);
  listener(oldest());
  return () => { listeners.delete(listener); };
}
